var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3.6,
    d: "M22.666 4c0.679-0.663 1.609-1.072 2.634-1.072 2.083 0 3.772 1.689 3.772 3.772 0 1.025-0.409 1.955-1.073 2.635l-17.999 17.999-7.334 2 2-7.334 18-18z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M1.333 16s5.333-10.667 14.667-10.667c9.333 0 14.666 10.667 14.666 10.667s-5.333 10.667-14.666 10.667c-9.334 0-14.667-10.667-14.667-10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M16 20c2.209 0 4-1.791 4-4s-1.791-4-4-4v0c-2.209 0-4 1.791-4 4s1.791 4 4 4v0z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-off",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M23.92 23.92c-2.175 1.672-4.923 2.697-7.908 2.747l-0.012 0c-9.334 0-14.667-10.667-14.667-10.667 1.713-3.152 3.978-5.791 6.689-7.877l0.058-0.043M13.2 5.653c0.833-0.203 1.788-0.32 2.771-0.32 0.010 0 0.020 0 0.030 0h-0.002c9.333 0 14.666 10.667 14.666 10.667-0.871 1.615-1.827 3.008-2.91 4.289l0.030-0.036M18.826 18.827c-0.732 0.782-1.77 1.269-2.922 1.269-2.209 0-4-1.791-4-4 0-1.152 0.487-2.191 1.267-2.921l0.002-0.002M1.333 1.333l29.333 29.334"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-log-out",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M12 28h-5.334c-1.472-0.001-2.665-1.194-2.666-2.666v-18.668c0-1.472 1.194-2.666 2.666-2.666v0h5.334M21.334 22.666l6.666-6.666-6.666-6.666M28 16h-16"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pie-chart-02",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#323f47",
    style: {
      stroke: "var(--color1, #323f47)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M22.933 18.667c0.369 0 0.555 0 0.704 0.083 0.129 0.075 0.231 0.186 0.292 0.32l0.002 0.004c0.067 0.156 0.049 0.324 0.016 0.659-0.56 5.414-5.098 9.6-10.613 9.6-5.891 0-10.667-4.776-10.667-10.667 0-5.516 4.187-10.054 9.555-10.61l0.046-0.004c0.335-0.032 0.501-0.049 0.659 0.017 0.138 0.063 0.249 0.164 0.322 0.29l0.002 0.003c0.083 0.149 0.083 0.335 0.083 0.704v8.533c0 0.373 0 0.56 0.073 0.703 0.065 0.126 0.165 0.226 0.287 0.289l0.004 0.002c0.143 0.073 0.329 0.073 0.703 0.073h8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9be1a0",
    style: {
      stroke: "var(--color2, #9be1a0)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M18.667 3.733c0-0.369 0-0.555 0.083-0.704 0.075-0.129 0.186-0.231 0.32-0.292l0.004-0.002c0.156-0.067 0.324-0.049 0.659-0.016 5.049 0.522 9.026 4.498 9.544 9.501l0.004 0.046c0.033 0.335 0.051 0.501-0.016 0.659-0.063 0.138-0.164 0.249-0.29 0.322l-0.003 0.002c-0.151 0.083-0.335 0.083-0.704 0.083h-8.533c-0.373 0-0.56 0-0.703-0.073-0.126-0.065-0.226-0.165-0.289-0.287l-0.002-0.004c-0.073-0.141-0.073-0.328-0.073-0.701v-8.533z"
  })), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-settings",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M16 20c2.209 0 4-1.791 4-4s-1.791-4-4-4v0c-2.209 0-4 1.791-4 4s1.791 4 4 4v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M25.868 20c-0.118 0.261-0.187 0.567-0.187 0.888 0 0.599 0.239 1.142 0.628 1.538l0.080 0.080c0.483 0.483 0.782 1.15 0.782 1.887 0 1.474-1.195 2.669-2.669 2.669-0.737 0-1.404-0.299-1.887-0.782v0l-0.080-0.080c-0.396-0.388-0.939-0.627-1.538-0.627-0.321 0-0.627 0.069-0.902 0.193l0.014-0.006c-0.789 0.344-1.33 1.115-1.334 2.014v0.226c0 1.473-1.194 2.667-2.667 2.667s-2.667-1.194-2.667-2.667v0-0.12c-0.022-0.922-0.608-1.702-1.425-2.009l-0.015-0.005c-0.261-0.118-0.567-0.187-0.888-0.187-0.599 0-1.142 0.239-1.538 0.628l-0.080 0.080c-0.484 0.492-1.158 0.797-1.902 0.797-1.474 0-2.668-1.195-2.668-2.668 0-0.744 0.305-1.417 0.796-1.901l0-0 0.080-0.080c0.388-0.396 0.628-0.94 0.628-1.539 0-0.322-0.069-0.628-0.193-0.903l0.006 0.014c-0.344-0.787-1.114-1.328-2.011-1.332h-0.229c-1.473 0-2.667-1.194-2.667-2.667s1.194-2.667 2.667-2.667v0h0.12c0.922-0.022 1.702-0.608 2.009-1.425l0.005-0.015c0.118-0.261 0.187-0.566 0.187-0.888 0-0.599-0.239-1.142-0.627-1.539l0 0-0.080-0.080c-0.483-0.483-0.782-1.15-0.782-1.887 0-1.474 1.195-2.669 2.669-2.669 0.737 0 1.404 0.299 1.887 0.782l0.080 0.080c0.396 0.388 0.939 0.627 1.538 0.627 0.321 0 0.627-0.069 0.902-0.193l-0.014 0.006h0.106c0.789-0.344 1.33-1.115 1.334-2.014v-0.226c0-1.473 1.194-2.667 2.667-2.667s2.667 1.194 2.667 2.667v0 0.12c0.003 0.898 0.544 1.67 1.318 2.008l0.014 0.006c0.262 0.119 0.567 0.188 0.889 0.188 0.599 0 1.142-0.24 1.539-0.628l0.080-0.080c0.483-0.486 1.151-0.787 1.89-0.787 1.471 0 2.664 1.193 2.664 2.664 0 0.003 0 0.006 0 0.009v-0c0 0 0 0.001 0 0.002 0 0.736-0.298 1.402-0.78 1.884l-0.080 0.080c-0.388 0.396-0.628 0.94-0.628 1.539 0 0.322 0.069 0.628 0.193 0.903l-0.006-0.014v0.106c0.344 0.788 1.114 1.33 2.011 1.334h0.227c1.472 0 2.666 1.194 2.666 2.666s-1.194 2.666-2.666 2.666h-0.12c-0.898 0.004-1.668 0.546-2.006 1.32l-0.006 0.014z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M12 4h8"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3.6,
    d: "M4 8h24M25.334 8l-0.936 14.026c-0.14 2.104-0.21 3.156-0.664 3.954-0.406 0.703-0.997 1.259-1.709 1.61l-0.023 0.010c-0.826 0.4-1.88 0.4-3.99 0.4h-4.024c-2.11 0-3.164 0-3.99-0.4-0.735-0.361-1.326-0.917-1.722-1.601l-0.010-0.019c-0.454-0.798-0.524-1.85-0.664-3.954l-0.936-14.026"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-upload",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M28 20v5.333c0 0 0 0.001 0 0.002 0 1.472-1.193 2.666-2.666 2.666-0.001 0-0.001 0-0.002 0h-18.666c-1.473 0-2.667-1.194-2.667-2.667v0-5.333M22.666 10.667l-6.666-6.667-6.667 6.667M16 4v16"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3.4286,
    d: "M24 8l-16 16M8 8l16 16"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 6.667v18.667M6.667 16h18.667"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-exclamation-mark",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9be1a0",
    style: {
      fill: "var(--color1, #9be1a0)"
    },
    d: "M13.473 18.545c0.122 1.265 0.329 2.205 0.611 2.826 0.288 0.618 0.797 0.927 1.533 0.927 0.137 0 0.26-0.022 0.383-0.047 0.125 0.025 0.247 0.047 0.385 0.047 0.733 0 1.245-0.308 1.53-0.927 0.285-0.621 0.487-1.561 0.611-2.826l0.655-9.772c0.121-1.905 0.182-3.271 0.182-4.1 0-1.129-0.294-2.010-0.884-2.643-0.593-0.633-1.373-0.947-2.337-0.947-0.051 0-0.090 0.010-0.141 0.013-0.048-0.003-0.087-0.015-0.137-0.015-0.967 0-1.745 0.316-2.337 0.948-0.591 0.634-0.887 1.516-0.887 2.643 0 0.829 0.061 2.196 0.183 4.102l0.652 9.77zM16.025 25.871c-0.937 0-1.732 0.295-2.394 0.886-0.66 0.592-0.991 1.309-0.991 2.153 0 0.951 0.335 1.7 0.999 2.244 0.669 0.544 1.447 0.816 2.337 0.816 0.906 0 1.697-0.268 2.374-0.806 0.675-0.535 1.012-1.289 1.012-2.255 0-0.842-0.323-1.561-0.969-2.153-0.647-0.591-1.436-0.887-2.371-0.887z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vector",
    viewBox: "0 0 28 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9be1a0",
    style: {
      fill: "var(--color1, #9be1a0)"
    },
    d: "M28.361 2.088c-0.118-0.401-0.318-0.771-0.585-1.085s-0.597-0.565-0.965-0.737c-0.366-0.178-0.767-0.267-1.171-0.263h-22.77c-0.404-0.024-0.807 0.061-1.171 0.246-0.377 0.173-0.712 0.431-0.981 0.755-0.267 0.314-0.467 0.683-0.585 1.083-0.123 0.397-0.16 0.817-0.111 1.231l2.595 22.972c0.174 1.572 0.902 3.019 2.041 4.069 1.114 1.049 2.562 1.633 4.067 1.641h11.076c1.509-0.007 2.963-0.591 4.082-1.641 1.124-1.060 1.843-2.505 2.025-4.069l1.408-12.913v-0.197l1.092-9.845c0.061-0.415 0.045-0.838-0.047-1.247zM12.379 27.274h-1.582c-1.025-0.059-2.001-0.475-2.769-1.181-0.766-0.715-1.269-1.684-1.424-2.74l-0.38-2.822c-0.049-0.43 0.067-0.863 0.322-1.206s0.63-0.569 1.043-0.629 0.834 0.050 1.17 0.307c0.336 0.257 0.562 0.64 0.629 1.068l0.38 2.789c0.043 0.305 0.188 0.584 0.411 0.788 0.221 0.21 0.507 0.333 0.807 0.345h1.582c0.42 0 0.822 0.173 1.119 0.481s0.463 0.725 0.463 1.16-0.167 0.853-0.463 1.16c-0.297 0.308-0.699 0.481-1.119 0.481h-0.19zM25.038 12.13c-3.339 0.673-6.187 0.804-9.209-1.641-3.75-3.068-8.291-2.084-12.659-0.476l-0.791-6.957c-0.016-0.070-0.016-0.143 0-0.213 0.022-0.069 0.060-0.131 0.111-0.18 0.037-0.061 0.093-0.107 0.158-0.131 0.062-0.018 0.128-0.018 0.19 0h22.975c0.059 0.034 0.113 0.079 0.158 0.131 0.047 0.049 0.079 0.113 0.095 0.18 0.024 0.075 0.024 0.155 0 0.23l-1.029 9.057z"
  })), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3.2,
    d: "M8 12l8 8 8-8"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-water-decrease",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.44,
    d: "M10.286 16h11.429"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-water-increase",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.44,
    d: "M16 10.286v11.429"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.44,
    d: "M10.286 16h11.429"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.7a0a6a2fe741e385346944aa16e0db57.svg";
export { ForwardRef as ReactComponent };